import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, StyleSheet } from '@react-pdf/renderer';
const styles = StyleSheet.create({
    text: {
        fontWeight: 'bold',
        fontSize: '18px',
        marginBottom: '17px',
    },
});
const SelectionsLabel = () => {
    const { t } = useTranslation();
    const title = t('Pages.Bap.yourSelectionsLabel');
    return _jsx(Text, { style: styles.text, children: title });
};
export default SelectionsLabel;
